/**
 * 调试：读取 document.cookie 中的 CASTGC / account（HttpOnly 的 cookie 此处为 undefined）。
 */
export const COOKIE_SSO_DEBUG_TAG = '[cookie-sso-debug]'

function getRawCookie(name) {
  if (typeof document === 'undefined' || !document.cookie) return undefined
  const cStart = document.cookie.indexOf(name + '=')
  if (cStart === -1) return undefined
  let cEnd = document.cookie.indexOf(';', cStart)
  if (cEnd === -1) cEnd = document.cookie.length
  try {
    return decodeURIComponent(document.cookie.substring(cStart + name.length + 1, cEnd))
  } catch (e) {
    return document.cookie.substring(cStart + name.length + 1, cEnd)
  }
}

export function logCookieSsoTokens(context = '') {
  const CASTGC = getRawCookie('CASTGC')
  const account = getRawCookie('account')
  console.log(`${COOKIE_SSO_DEBUG_TAG} ${context}`, {
    CASTGC,
    account,
    effectiveOr: CASTGC || account || undefined
  })
  return { CASTGC, account }
}



// WEBPACK FOOTER //
// ./src/utils/cookieSsoDebug.js